import {OrbitService} from '../services/orbit.service';
import {Component, OnInit, EventEmitter, Output} from '@angular/core';
import {TourNavigationService} from '../services/tour-navigation.service';
import {CameraService} from '../services/camera.service';
import {ProToolsUiManagerService} from '../services/pro-tools-ui-manager.service';
import {ZoomService} from '../services/zoom.service';

@Component({
  selector: 'app-scene-nav-toolbar',
  templateUrl: './scene-nav-toolbar.component.html',
  styleUrls: ['./scene-nav-toolbar.component.scss']
})
export class SceneNavToolbarComponent implements OnInit {

  tourStep: number;
  events: any = {};

  mouseDownId: any = -1;
  showScaleControl = true;
  min = 1;
  max = 20;
  zoom = 10;

  @Output() onMoveCamera = new EventEmitter<boolean>();

  constructor(
    public tourNavigationService: TourNavigationService,
    private cameraManager: CameraService,
    private orbitControl: OrbitService,
    private zoomSrvc: ZoomService,
    proToolsUiManagerService: ProToolsUiManagerService
  ) {

    proToolsUiManagerService.proToolsModActive.subscribe(active => {
      this.showScaleControl = !active;
    });

    zoomSrvc.on3DScaleChange.subscribe(_ => this.zoom = zoomSrvc.getCurrentZoom());

    zoomSrvc.on2DScaleChange.subscribe(_ => this.zoom = zoomSrvc.getCurrentZoom());

    cameraManager.cameraTrackerSubj.subscribe(_ => this.zoom = zoomSrvc.getCurrentZoom());
  }

  resetCamera() {
    this.cameraManager.reset();
    this.zoomSrvc.reset();
  }

  change(direction: any) {
    this.onMoveCamera.emit(direction);
  }

  c0() {
    this.mouseDownId = setInterval(() => {

      this.change(0);

    }, 100);
  }

  c1() {
    this.mouseDownId = setInterval(() => {

      this.change(1);

    }, 100);
  }

  c2() {
    this.mouseDownId = setInterval(() => {

      this.change(2);

    }, 100);
  }

  c3() {
    this.mouseDownId = setInterval(() => {

      this.change(3);

    }, 100);
  }


  mouseUp() {
    if (this.mouseDownId !== -1) {
      clearInterval(this.mouseDownId);
      this.mouseDownId = -1;
    }
  }

  onZoomSliderChange(scale: any) {
    this.zoomSrvc.set(scale);
    console.log('zoom', scale);
  }

  ngOnInit() {
    this.tourNavigationService.Navigator.subscribe(value => this.tourStep = value);

    const arrowUp = document.querySelector('#triangle-up');
    const arrowDown = document.querySelector('#triangle-down');
    const arrowRight = document.querySelector('#triangle-right');
    const arrowLeft = document.querySelector('#triangle-left');

    arrowUp.addEventListener('mousedown', this.c0.bind(this));
    arrowUp.addEventListener('mouseup', this.mouseUp.bind(this));
    arrowUp.addEventListener('mouseout', this.mouseUp.bind(this));
    arrowDown.addEventListener('mousedown', this.c1.bind(this));
    arrowDown.addEventListener('mouseup', this.mouseUp.bind(this));
    arrowDown.addEventListener('mouseout', this.mouseUp.bind(this));
    arrowRight.addEventListener('mousedown', this.c2.bind(this));
    arrowRight.addEventListener('mouseup', this.mouseUp.bind(this));
    arrowRight.addEventListener('mouseout', this.mouseUp.bind(this));
    arrowLeft.addEventListener('mousedown', this.c3.bind(this));
    arrowLeft.addEventListener('mouseup', this.mouseUp.bind(this));
    arrowLeft.addEventListener('mouseout', this.mouseUp.bind(this));
  }


}



// WEBPACK FOOTER //
// ./src/app/scene-nav-toolbar/scene-nav-toolbar.component.ts